<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Shipment Tracking </strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-col sm="12" >
                  <b-form-group label="Shipment Id" :label-cols="4"> 
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter Shipment Id ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                   </b-form-group> 
                   </b-col>         
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
          </div> 
				</b-card>

				<!-- Shipment Details -->
			<b-card
				v-if="isConsignmentMasterGetStatus && ConsignmentMasterGetdata.length"
				header="Shipment Details"
			>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Shipping ID :</strong>
						{{ ConsignmentMasterGetdata[0].shippingid }}
					</b-col>

					<b-col md="6">
						<strong>Shipment Status :</strong>
						{{ ConsignmentMasterGetdata[0].shipmentstatus }}
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Delivery Status :</strong>
						{{ ConsignmentMasterGetdata[0].deliverystatus }}
					</b-col>

					<b-col md="6">
						<strong>Order Flow :</strong>
						{{ ConsignmentMasterGetdata[0].orderflow }}
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Service Type :</strong>
						{{ ConsignmentMasterGetdata[0].servicetype }}
					</b-col>

					<b-col md="6">
						<strong>Pickup Location :</strong>
						{{ ConsignmentMasterGetdata[0].pickuplocationname }}
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Agent Name :</strong>
						{{ ConsignmentMasterGetdata[0].agentname }}
					</b-col>

					<b-col md="6">
						<strong>Vendor Name :</strong>
						{{ ConsignmentMasterGetdata[0].vendor_name }}
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Shipping Address :</strong>
						{{ ConsignmentMasterGetdata[0].shipaddress1 }}
					</b-col>

					<b-col md="6">
						<strong>Delivery Lat/Long :</strong>
						{{ ConsignmentMasterGetdata[0].shiplonglat }}
					</b-col>
				</b-row>

				<b-row class="mb-3">
					<b-col md="6">
						<strong>Created Date :</strong>
						{{ ConsignmentMasterGetdata[0].createddate | datechange }}
					</b-col>

					<b-col md="6">
						<strong>Last Modified :</strong>
						{{ ConsignmentMasterGetdata[0].lastmodifieddate | datechange }}
					</b-col>
				</b-row>

				<!-- KSA Only -->
				<b-row
					class="mb-3"
					v-if="country === 'KSA'"
				>
					<b-col md="6">
						<strong>Order Type :</strong>
						{{ ConsignmentMasterGetdata[0].ordertype }}
					</b-col>

					<b-col md="6">
						<strong>Customer Name & Mobile :</strong>
						{{ ConsignmentMasterGetdata[0].shipnameno }}
					</b-col>
				</b-row>

			</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      isBusy: false,
      is_history_Busy:false,
      customer: {},
      outlined:true,
      bordered: true,
      data: [],
      items: [],
      dlvstatus:[],
      servicetype:[],
      iswarrantyshipment:[],
      rpickdoneimg:[],
      img1:[],
      is_mark_ofd:0,
      imgpath:[],
      rpickdoneimgpath:[],
      urlrpickdoneImg:[],
      urlImg: [],
      rpickdonepath:[],
      isBusycustom:false,
       customlogdata: [],
       isBusysms:false,
        smslogdata: [],
        isBusyosr:false,
        osremaildata:[],
        searchvaluesarr:[],
        shippingid:'',
      customFields:[{key:'shippingid' , label:'Shipping Id' },{key:'drivername' , label: 'Driver Name' },{key:'vehiclenumber' , label:'Vehicle Number' },{key:'shipmentstatus' , label: 'Shipment Status'},{key:'type' , label: 'Type'},{key:'created_datetime' , label:'Date' },{key:'pushflag' , label:'Status' }],
      isBusylogistic:false,
      logisticlogdata: [],
      fields: [],
       
      response_msg:'',
      isBusyhistory:false,
      ConsignmentMasterGetdata: [],
      isBusyMaster:false,
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      country:'',
      is_superadmin:0,
      is_qwik_user:'',

    }
  },
  created: function () {
    let userdata = localStorage.getItem("userData");
    let userInfo = JSON.parse(userdata);
    this.is_superadmin = `${userInfo.is_superadmin}`
    this.is_qwik_user = `${userInfo.is_qwik_user}`
      console.log("COUNTYYYYYYYYYY",userInfo)
      this.country=userInfo.country
      this.fields=[];
      if(userInfo.country==='KSA'){
            this.fields= [
              {key: 'shippingidsign', label: 'Shipping Id [Order Id]'}, 
              {key: 'pickuplocationname',label:'Pickup Location Name'}, 
              {key: 'servicetype',label:'Service Type'},
              {key: 'shipmentstatus',label:'Shipment Status'},
              {key: 'deliverystatus',label:'Delivery Status'},
              {key: 'agentname', label: 'Agent Name'},
              {key: 'shipnameno', label: 'Customer Name & Mob No.'},
              
              {key: 'vendor_name', label: 'Vendor Name'},
              {key: 'mobilenumber', label: 'DA Mobile Number'},
              {key: 'shipaddress1', label: 'Delivery Address'},
              {key: 'ordertype', label: 'Order Type'},
              {key: 'pickuplatlong', label: 'Delivery LatLong'},
              
              {key: 'createddate', label: 'Created Date'},
              {key: 'lastmodifieddate', label: 'Last Modified Date'}

              ]
          }else{
            this.fields = [
                {key: 'shippingidsign', label: 'Shipping Id [Order Id]'}, 
                {key: 'pickuplocationname',label:'Pickup Location Name'}, 
                {key: 'servicetype',label:'Service Type'},
                {key: 'shipmentstatus',label:'Shipment Status'},
                {key: 'deliverystatus',label:'Delivery Status'},
                {key: 'agentname', label: 'Agent Name'},
                {key: 'vendor_name', label: 'Vendor Name'},
                {key: 'mobilenumber', label: 'Mobile Number'},
                {key: 'shipaddress1', label: 'Shipping Address'},
                
                {key: 'shiplonglat', label: 'Delivery LatLong'},
                {key: 'createddate', label: 'Created Date'},
                {key: 'lastmodifieddate', label: 'Last Modified Date'}
               ]
          }
  },
  methods: {
    validateForm(scope) {
     
      // var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         
          var shipmentid = this.customer.shipmentid
          var searchvalues = shipmentid.split(',')
          for (var i = 0; i < searchvalues.length; i++) {
            this.searchvaluesarr.push(`${searchvalues[i]}`)
          }
         // const customerGetAllobj = {
          //   shippingid: searchvaluesarr
          // }
           this.babygeardata=[];
          this.shippingid=this.customer.shipmentid;
          if(this.is_qwik_user == 'yes'){ 
            if(this.shippingid.startsWith('Q')){
              this.tracking_main(this.shippingid);
              this.trackinghistory(this.searchvaluesarr);
              this.status_logistic(this.shippingid);
              this.status_custom(this.shippingid);
              this.status_sms(this.shippingid);
              this.osr_email_details(this.shippingid);
            }
            else{
              this.$fire({
                text: "Invalid Shipment",
                type: "error",
                timer: 30000
              });
              this.shippingid = '';
              this.logisticlogdata=[]
              this.customlogdata = []
              this.smslogdata = []
              this.osremaildata=[];
              this.ConsignmentMasterGetdata = []
              this.data=[]
            }
          }
          else{
          
            if(this.is_superadmin == 1){
              this.tracking_main(this.shippingid);
              this.trackinghistory(this.searchvaluesarr);
              this.status_logistic(this.shippingid);
              this.status_custom(this.shippingid);
              this.status_sms(this.shippingid);
              this.osr_email_details(this.shippingid);
            }
            else{
              if(!this.shippingid.startsWith('Q')){
                 this.tracking_main(this.shippingid);
                this.trackinghistory(this.searchvaluesarr);
                this.status_logistic(this.shippingid);
                this.status_custom(this.shippingid);
                this.status_sms(this.shippingid);
                this.osr_email_details(this.shippingid);
              }
              else{
                  this.$fire({
                  text: "Invalid Shipment",
                  type: "error",
                  timer: 30000
                });

                this.shippingid = '';
                this.logisticlogdata=[]
                this.customlogdata = []
                this.smslogdata = []
                this.osremaildata=[];
                this.ConsignmentMasterGetdata = []
                this.data=[]
              }
            }
          }
          
   
        }
      })
    },

    tracking_main:function(value){

          const Getobj = {
            shippingid: value
          }

         this.isBusyMaster = true;
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getShipmentTrackingFromArchivalTable`, Getobj)
            .then((result) => {
              this.isBusyMaster=false;
               // console.log("result",result);
              if (result.body.length > 0) {
               
                this.ConsignmentMasterGetdata = result.body
                console.log("ConsignmentMasterGetdata",this.ConsignmentMasterGetdata);
                if(this.ConsignmentMasterGetdata[0].orderflow==='Reverse' && this.country==='KSA'){
                  this.fields[11].label="PickUp LatLong"
                  // console.log("fields@@@@@@@@@@",this.fields[11].label);
                } else if(this.ConsignmentMasterGetdata[0].orderflow==='Forward' && this.country==='KSA'){
            this.fields[11].label="Delivery LatLong"
           } 
            this.is_mark_ofd=this.ConsignmentMasterGetdata[0].is_mark_ofd
            this.iswarrantyshipment=this.ConsignmentMasterGetdata[0].iswarrantyshipment;
            console.log("iswarrantyshipment",this.iswarrantyshipment);
                // alert(this.ConsignmentMasterGetdata[0].is_mark_ofd);
                this.img1 = result.body[0].vendorsign
                this.dlvstatus = result.body[0].shipmentstatus;
                this.servicetype = result.body[0].servicetype;
                console.log("this.dlvstatus",this.servicetype);
                this.rpickdoneimg=
                
                this.urlImg = result.body[0].shipment_images
                this.imgpath= JSON.parse(this.urlImg);

                
               this.urlrpickdoneImg=result.body[0].shipment_images_rpickdone;
                // console.log(" urlrpickdoneImg", this.urlrpickdoneImg);
                  this.rpickdoneimgpath=JSON.parse(this.urlrpickdoneImg);
                  // console.log("  this.rpickdoneimgpath", this.rpickdoneimgpath[0].imagepath);
                this.isConsignmentMasterGetStatus = 1

                // this.isBusy = false;
                if(this.iswarrantyshipment=="1" && this.dlvstatus=="RTD" && this.servicetype=="return"){
                  // alert("in");
                  this.babygearpushlog(value);
                }

              
              } else {
                alert('Data not found!')
                this.ConsignmentMasterGetdata = []
                this.isConsignmentMasterGetStatus = 1
               
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
    },

    clear: function() {
      this.customer = {}
      this.searchvaluesarr=[]
      this.ConsignmentMasterGetdata = []
      this.data = []
      this.dlvstatus=[]
      this.is_mark_ofd=0;
      this.response_msg='';
      // this.fields=[{}];
      this.errors.clear('form-1')
      // var searchlisting = document.getElementById('searchlisting')
      // searchlisting.style.display = 'none'
      // var searchlisting2 = document.getElementById('searchlisting2')
      // searchlisting2.style.display = 'none'
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
};
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }

</style>